module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0115.jpg?v=a86ed765";